<template>
	<div class="login">
		<div class="login-sub-cont">
			<div class="header5">Hi There!</div>
			<div class="header2">Sign in</div>

			<div class="paragraph">Log in here to access your account</div>
			<form class="login-form-container" action="#">
				<InputBox placeHolder="Username or email" v-model="username" />
				<InputBox placeHolder="Password" type="password" v-model="password" />
				<div class="mid-sec">
					<div class="header5 forgot" @click="goForgot">Forgot Password?</div>
					<Button title="Login Now" :onClick="submit" />
				</div>
			</form>
			<form class="login-register-cont" action="#">
				<div class="header5 register">Don’t have an account?</div>
				<Button title="Register" :onClick="registerRoute" buttonType="outline" />
			</form>
		</div>
	</div>
</template>

<script>
// import { Prop } from "vue-property-decorator";
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { AUTH_REQUEST } from "../store/constants";

import localData from "@/store/utils/localdata";
export default {
	name: "login",
	title: "Login",
	components: {
		InputBox,
		Button,
	},
	data() {
		return {
			username: "",
			password: "",
		};
	},
	methods: {
		async submit() {
			if (!this.username) {
				this.$toast.open({
					message: "Missing fields",
					position: "top",
					type: "error",
				});
			}
			const user = {
				email: this.username,
				password: this.password,
			};
			try {
				const results = await this.$store.dispatch(AUTH_REQUEST, user);
				this.goLoginSuccess(results);
			} catch (ex) {
				this.$toast.open({
					message: "Incorrect email or password",
					position: "top",
					type: "error",
				});
			}
		},
		registerRoute() {
			this.$router.push({ name: "Register" });
		},
		async goLoginSuccess(results) {
			if (this.$route.query.path) {
				if (this.$route.query.path.includes("confirm?pid")) {
					//TODO: Fix confrim form login
					this.$router.push(`${this.$route.query.path}&purchaseDate=&purchaseAmount=&filingOption=${this.$route.query.filingOption}`);
				}
				this.$router.push(this.$route.query.path);
				return true;
			}
			this.$router.push("/account");
		},
		goForgot() {
			this.$router.push({ name: "Forgot" });
		},
		goLogin() {
			this.$router.go(0);
		},
	},
};
</script>

<style scoped lang="scss">
.login {
	background: var(--dark-blue);
	margin: 0;
	max-width: unset;
	min-height: unset;
	padding: 0;
	.login-sub-cont {
		padding: 0 5vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: calc(100vh - 105px);
		align-items: center;
		// max-width: 1850px;
		max-width: 1650px;
		margin: auto;
		.header5 {
			color: var(--accent);
			font-size: 18px;
		}
		.header2 {
			color: var(--white);
			font-size: 51px;
			line-height: 51px;
		}
		.paragraph {
			text-align: center;
			color: var(--white);
			opacity: 0.5;
			margin-top: 20px;
		}
		.login-form-container {
			max-width: 500px;
			margin-top: 50px;
			width: 100%;
			.mid-sec {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-top: 11px;
				align-items: center;
				.forgot {
					text-align: left;
					margin-bottom: unset;
					color: var(--white);
					opacity: 0.5;
					cursor: pointer;
				}
				.forgot:hover {
					color: var(--accent);
					cursor: pointer;
				}
			}
		}
		.back-login {
			color: white;
			margin-top: 2px;
			width: 500px;
			text-align: left;
			margin: auto;
			opacity: 1;
			span {
				font-style: normal;
				font-weight: 500;
				font-size: 18px;
				line-height: 27px;
				text-align: center;
				cursor: pointer;
				color: rgba(80, 205, 243, 1);
			}
			& :hover {
				color: var(--primary);
			}
		}
		.log-cont {
			margin-top: 60px;
			margin-bottom: 70px;
		}
		.login-register-cont {
			max-width: 500px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin-top: 65px;
			width: 100%;
			.header5.register {
				padding-bottom: unset;
				margin-bottom: unset;
				color: var(--white);
				font-size: 18px;
			}
		}
	}
}
@media screen and (max-width: 414px) {
	.login .login-sub-cont {
		height: 85vh;
		.header5 {
			padding-bottom: 4vw;
			font-size: 14px;
			margin-bottom: unset;
		}
		.header2 {
			padding-bottom: 4vw;
			font-size: 36px;
			line-height: 36px;
		}
		.paragraph {
			font-size: 16px;
			line-height: 32px;
			width: unset;
			margin: unset;
			margin-top: 12px;
		}
		.container {
			padding-top: 15vw;
			margin-top: unset;
			.forgot {
				font-weight: normal;
				font-size: 14px;
				line-height: 21px;
				color: var(--white);
				opacity: 0.5;
				margin: 15px 0;
			}
		}
		.login-register-cont {
			.header5.register {
				font-size: 14px;
				text-align: left;
			}
			.outline.button {
				border-radius: 30px;
				color: var(--white);
				border-color: var(--white);
			}
		}
	}
}
</style>
